import { TAG_VALUE_GROUPS } from "@/constants/conditionCategories";
import { uid } from "./segmentFormUtils";

export const INTEREST_GROUP_OPTIONS = TAG_VALUE_GROUPS.interests.map((g) => ({
  label: g.label,
  options: g.options,
}));

export const MEMBERSHIP_CATEGORIES = new Set([
  "location",
  "content",
  "platform",
]);

const numericOptions = (cfg) =>
  cfg.options.map((o) => ({ value: Number(o.value), label: o.label }));

export const membershipFields = (categoryId, cfg) => {
  if (categoryId === "location") {
    return [
      {
        field: "country",
        op: "in",
        options: cfg.country.options,
        placeholder: "Countries…",
      },
      {
        field: "region",
        op: "in",
        options: cfg.region.options,
        placeholder: "Regions…",
      },
      {
        field: "city",
        op: "in",
        options: cfg.city.options,
        placeholder: "Cities…",
      },
    ];
  }
  if (categoryId === "content") {
    return [
      {
        field: "categories",
        op: "intersects",
        options: cfg.categories.options,
        placeholder: "Content categories…",
      },
      {
        field: "channelId",
        op: "in",
        options: numericOptions(cfg.channelId),
        placeholder: "Channels…",
      },
    ];
  }
  if (categoryId === "platform") {
    return [
      {
        field: "platform",
        op: "in",
        options: cfg.platform.options,
        placeholder: "Platforms…",
      },
      {
        field: "deviceType",
        op: "in",
        options: numericOptions(cfg.deviceType),
        placeholder: "Device types…",
      },
      {
        field: "providerUuid",
        op: "in",
        options: cfg.providerUuid.options,
        placeholder: "Providers…",
      },
    ];
  }
  return [];
};

export const tagOp = (combinator, tab) =>
  tab !== "exclude" && combinator === "and" ? "arrayContains" : "intersects";

export const tagOpForCategory = (categoryId, combinator, tab) =>
  categoryId === "interests" ? "intersects" : tagOp(combinator, tab);

export const makeTagCondition = (categoryId, op) => ({
  id: uid(),
  field: "tags",
  op,
  value: [],
  _cat: categoryId,
  disabled: false,
});
